import React from 'react';
import { motion } from 'framer-motion';
export function SocialProofSection() {
  const metrics = [{
    value: '35+',
    label: 'Years in Business'
  }, {
    value: '800+',
    label: 'Trusted By Wholesale Partners'
  }, {
    value: '3k+',
    label: 'Premium Product'
  }];
  return <section className="py-20 bg-tcp-red relative overflow-hidden" data-id="element-72" data-mp="30seyyu7zxvmo">
      {/* Dark overlay to make it a deep, rich red */}
      <div className="absolute inset-0 bg-black/40" data-id="element-73" data-mp="2d3m12s7tddpf" />

      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/30 to-transparent" data-id="element-74" data-mp="2849feasoicof" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/30 to-transparent" data-id="element-75" data-mp="2mxcn7qggxc1y" />

      <div className="container mx-auto px-6 max-w-7xl relative z-10" data-id="element-76" data-mp="2986te579tce">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 divide-y md:divide-y-0 md:divide-x divide-white/20" data-id="element-77" data-mp="2bb48j8omor5">
          {metrics.map((metric, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="text-center py-6 md:py-0 flex flex-col items-center justify-center" data-id="element-78" data-mp="yeh8jyf3h3z6" data-mpi={index}>
              <h4 className="font-display text-5xl md:text-6xl font-bold text-white mb-2 tracking-tight" data-id="element-79" data-mp="klrmjtzkfz22">
                {metric.value}
              </h4>
              <p className="text-white/80 uppercase tracking-widest text-sm font-medium" data-id="element-80" data-mp="th7kam3fyycx">
                {metric.label}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}